import canvas from '@classes/canvas'
import type { MeterId, MeterOptions } from '@constants/gauges_meters_consts'
import type { Point } from '@shared_types/config_types'
import { formatDateTime } from '@utils/time_utils'
import moment from 'moment-timezone'

import type { MainParams, StyleParams } from '../Meter'

export function drawTimeGauge (
  clockId: string,
  sunrise: Date | null | undefined,
  sunset: Date | null | undefined,
  mainParams: MainParams,
  styleParams: StyleParams,
  options: MeterOptions[MeterId.TIME]
) {
  const { center, radius, value, dpx, ctx, redraw } = mainParams
  const { strokeWidth, color, arcColor } = styleParams

  let isDrawingSunrise = false
  let result: Point

  if (clockId.includes('locale')) {
    clockId = moment.tz.guess()
  }

  if (sunrise instanceof Date && sunset instanceof Date) {
    const dateAtLocation = moment().tz(clockId)
    const currentTime = dateAtLocation.toDate()
    const hourOffset = dateAtLocation.utcOffset() / 60

    let h: number, m: number

    if (currentTime > sunrise && currentTime < sunset) {
      // draw sunset
      h = (sunset.getUTCHours() + hourOffset) % 24
      m = sunset.getMinutes()
      const moon = ((h * 60 + m) / (12 * 60)) * 360
      result = canvas.xy(moon, center, radius * 0.8)
    } else {
      // draw sunrise
      h = (sunrise.getUTCHours() + hourOffset) % 24
      m = sunrise.getMinutes()
      const sun = ((h * 60 + m) / (12 * 60)) * 360
      result = canvas.xy(sun, center, radius * 0.8)
      isDrawingSunrise = true
    }
  }

  const date = moment(value)
  const hours = date.hour()
  const minutes = date.minutes()
  const hoursAngle = ((hours * 60 + minutes) / (12 * 60)) * 360
  const minutesAngle = (minutes / 60) * 360
  const hours1XY = canvas.xy(hoursAngle, center, radius - dpx * 30)
  const minutes1XY = canvas.xy(minutesAngle, center, radius - dpx * 30)
  const hoursXY = canvas.xy(hoursAngle, center, radius * 0.7)
  const minutesXY = canvas.xy(minutesAngle, center, radius * 0.9)

  canvas.drawing(() => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
    redraw()
    canvas.drawHand(ctx, hours1XY.x, hours1XY.y, hoursXY.x, hoursXY.y, (strokeWidth || 2) * dpx, arcColor)
    canvas.drawHand(ctx, minutes1XY.x, minutes1XY.y, minutesXY.x, minutesXY.y, (strokeWidth || 0) * dpx, arcColor)
    canvas.drawPieSlice(ctx, 2, 8, 0, dpx * 2, Math.PI, color || arcColor)
    canvas.drawArc(ctx, center, center, radius, 0, Math.PI * 2, arcColor, dpx + 1)
    canvas.drawTimeValue(
      ctx,
      center,
      `${formatDateTime(date, true)}`,
      `${formatDateTime(date, false, true)}`,
      14 * dpx,
      dpx,
      color
    )

    if (!result?.x || !result?.y) {
      // unable to draw
    } else if (isDrawingSunrise) {
      canvas.drawSun(ctx, result.x, result.y, radius / 6, 0, Math.PI * 2, options.isBig)
    } else {
      canvas.drawMoon(ctx, result.x, result.y, radius / 6, 0, Math.PI * 2, options.isBig)
    }
  })
}
